import styled from 'styled-components';

export const SidebarContainer = styled.div`
  height: 100%;
  width: 285px;

  display: grid;
  grid-auto-flow: row;
  align-content: space-between;

  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;

  /* Tablet + Mobile (off-canvas sidebar) */
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    position: fixed;
    left: ${({ $isOpen }) => ($isOpen ? '0' : '-100%')};
    top: 0;
    width: 280px;
    height: 100vh;
    z-index: 1000;
    border-radius: 0;
    background-color: ${({ theme }) => theme.colors.sidebarBackground};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    padding: ${({ theme }) => `0 ${theme.spacing.md} ${theme.spacing.md}`};
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const LogoImage = styled.div`
  width: 65px;
  height: 65px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const LogoText = styled.span`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text};
  margin-left: -10px;
  font-size: ${({ theme }) => theme.fontSizes.normal};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: ${({ theme }) => theme.fontSizes.small};
  }
`;

export const CloseButton = styled.button`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text};
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }

  /* Hide close button on desktop */
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: none;
  }
`;

export const NewChatSection = styled.div``;

export const NewChatButton = styled.button`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primaryForeground};
  border-radius: ${({ theme }) => theme.borderRadius.normal};
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.sm};
  border: none;
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSizes.normal};
  font-weight: 500;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.9;
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const Navigation = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing.lg};
`;

export const NavButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.text};
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSizes.normal};
  font-weight: 700;
  transition: opacity 0.2s ease;
  padding: ${({ theme }) => theme.spacing.sm} 0;

  &:hover {
    opacity: 0.7;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const PoweredBySection = styled.button`
  /* background-color: ${({ theme }) => theme.colors.cardBackground}; */
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  border: 1px solid ${({ theme }) => theme.colors.border};
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
`;

export const PoweredByContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
`;

export const PoweredByText = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.small};
  /* color: ${({ theme }) => theme.colors.text}; */
  color: ${({ theme }) => theme.colors.primaryForeground};
`;

export const PoweredByLogo = styled.div`
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 42px;
    height: 42px;
    object-fit: cover;
  }
`;

export const MobileOverlay = styled.div`
  display: none;

  /* Tablet + Mobile overlay */
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }
`;
